import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMuiSelectOption } from "../components/framework/muiAutocomplete2";
import { getVehicles } from "../services/vehicleService";
import { VehicleListItemDto } from "../models/transport/vehicle";
import { getVehicleGroups } from "../services/vehicleGroupService";
import { VehicleGroupItem } from "../models/vehicleGroup/vehicleGroupItem";

export interface VehicleState {
    vehicles: VehicleListItemDto[];
    options: IMuiSelectOption[];
    allVehicleGroupsLoading: boolean;
    allVehicleGroups: VehicleGroupItem[];
}

export const initialState: VehicleState = {
    vehicles: null,
    options: null,
    allVehicleGroupsLoading: true,
    allVehicleGroups: []
};

export const vehicleSlice = createSlice({
    name: "vehicle",
    initialState,
    reducers: {
        setVehicles: (state, action: PayloadAction<VehicleListItemDto[]>) => {
            state.vehicles = action.payload;
        },
        setOptions: (state, action: PayloadAction<IMuiSelectOption[]>) => {
            state.options = action.payload;
        },
        setAllVehicleGroups(state, action: PayloadAction<VehicleGroupItem[]>) {
            state.allVehicleGroups = action.payload;
        }
    }, extraReducers(builder) {
        builder
            .addCase(fetchAllVehicleGroups.pending, (state) => {
                state.allVehicleGroupsLoading = false;
            })
            .addCase(fetchAllVehicleGroups.fulfilled, (state, action) => {
                state.allVehicleGroupsLoading = true;
                state.allVehicleGroups = action.payload;
            })
            .addCase(fetchAllVehicleGroups.rejected, (state) => {
                state.allVehicleGroupsLoading = false;
            });
    },
});

export const { setVehicles, setOptions, setAllVehicleGroups } = vehicleSlice.actions;

export const fetchVehicleOptions = createAsyncThunk(
    "vehicle/options",
    async(_, thunkApi) => {
        const vehicles = await getVehicles(false, thunkApi.signal);
        thunkApi.dispatch(setVehicles(vehicles.data));
        thunkApi.dispatch(
            setOptions(
                vehicles.data.map((v) => ({
                    value: v.id,
                    label: `${v.registerNumber}, ${v.brand}`,
                }))
            )
        );
    }
);

export const fetchAllVehicleGroups = createAsyncThunk(
    "monitorView/fetchAllVehicleGroups",
    async(request: string[], { rejectWithValue }) => {
        try {
            const response = await getVehicleGroups(request);
            return response.data;
        } catch (err) {
            return rejectWithValue("Failed to fetch vehicle groups");
        }
    }
);

export const vehicleReducer = vehicleSlice.reducer;
